// Notez que toutes les clés sont maintenant en français,
// mais pour la continuité sur Matomo nous gardons les valeurs anglaises
export enum EventCategory {
  Defaut = "defaultCategory",
  General = "General",
  Parcours = "Parcours",
  Accompagnement = "Accompaniment",
  MontantAttendu = "Montant attendu",
  Followup = "Followup",
}
